import register from 'preact-custom-element'
import CarouselSwiper from 'modules/carousel-swiper/carousel-swiper'
import { useEffect, useRef } from 'preact/hooks'

function FeatureItems({ items }) {
  return items.map(
    (item) =>
      item && (
        <swiper-slide className="w-[284px] lg:w-[432px]">
          <div className="product-feature-carousel-item flex h-full flex-shrink-0 flex-col lg:w-[432px]">
            {item.image && (
              <div className="relative aspect-[348/306] w-full overflow-hidden lg:aspect-[416/440]">
                <img
                  src={item.image}
                  alt={item.heading || ''}
                  className="fit h-full w-full object-cover"
                  loading="lazy"
                />
              </div>
            )}
            <div className="flex flex-1 flex-col pt-4 lg:pt-6 pr-3 lg:pr-6">
              {item.heading && (
                <h5 className="text-[22px] leading-7 text-grey-1000 lg:text-6 lg:leading-8 mb-2">
                  {item.heading}
                </h5>
              )}
              {item.description && (
                <div className="mt-1 text-sm text-grey-700 leading-[22px]" dangerouslySetInnerHTML={{ __html: item.description }} />
              )}
            </div>
          </div>
        </swiper-slide>
      )
  )
}

function ProductFeatureCarousel({ items: itemsJson, sectionId }) {
  const items = itemsJson ? JSON.parse(itemsJson) : []
  const carouselInstanceRef = useRef(null)

  const options = {
    slidesPerView: 'auto',
    spaceBetween: 24,
    freeMode: {
      enabled: true,
      sticky: true
    },
    grabCursor: true,
    speed: 500,
    scrollbar: {
      draggable: true
    }
  }

  useEffect(() => {
    if (!sectionId) return

    const prevBtn = document.querySelector(`[data-product-feature-prev="${sectionId}"]`)
    const nextBtn = document.querySelector(`[data-product-feature-next="${sectionId}"]`)

    const handlePrev = () => {
      if (carouselInstanceRef.current) {
        carouselInstanceRef.current.slidePrev()
      }
    }

    const handleNext = () => {
      if (carouselInstanceRef.current) {
        carouselInstanceRef.current.slideNext()
      }
    }

    const updateButtonStates = () => {
      if (carouselInstanceRef.current && prevBtn && nextBtn) {
        const swiper = carouselInstanceRef.current
        if (swiper.isBeginning) {
          prevBtn.classList.add('swiper-button-disabled')
          prevBtn.setAttribute('aria-disabled', 'true')
        } else {
          prevBtn.classList.remove('swiper-button-disabled')
          prevBtn.setAttribute('aria-disabled', 'false')
        }
        if (swiper.isEnd) {
          nextBtn.classList.add('swiper-button-disabled')
          nextBtn.setAttribute('aria-disabled', 'true')
        } else {
          nextBtn.classList.remove('swiper-button-disabled')
          nextBtn.setAttribute('aria-disabled', 'false')
        }
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', handlePrev)
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', handleNext)
    }

    const checkSwiper = setInterval(() => {
      if (carouselInstanceRef.current) {
        updateButtonStates()
        carouselInstanceRef.current.on('slideChange', updateButtonStates)
        carouselInstanceRef.current.on('reachBeginning', updateButtonStates)
        carouselInstanceRef.current.on('reachEnd', updateButtonStates)
        clearInterval(checkSwiper)
      }
    }, 100)

    return () => {
      if (prevBtn) {
        prevBtn.removeEventListener('click', handlePrev)
      }
      if (nextBtn) {
        nextBtn.removeEventListener('click', handleNext)
      }
      clearInterval(checkSwiper)
    }
  }, [sectionId])

  const setCarouselInstance = (instance) => {
    carouselInstanceRef.current = instance
  }

  return (
    items.length > 0 && (
      <div className="overflow-hidden">
        <CarouselSwiper
          items={<FeatureItems items={items} />}
          className="carousel-swiper-product-feature"
          options={options}
          navigation={false}
          scrollbar={true}
          setCarouselInstance={setCarouselInstance}
        />
      </div>
    )
  )
}

if (!customElements.get('product-feature-carousel')) {
  register(ProductFeatureCarousel, 'product-feature-carousel', ['items', 'section-id'])
}
